import { Form, Space, Input, Button, Select, Col, Row, Divider, Radio, FormInstance } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useEffect, useState } from "react";

const data = [
  {
    key: 1,
    value: 1,
    label: "BÁSICO",
  },
  {
    key: 2,
    value: 2,
    label: "MEDIO",
  },
  {
    key: 3,
    value: 3,
    label: "ALTO",
  },
  {
    key: 4,
    value: 4,
    label: "AVANZADO",
  },
];
export interface Props {
  form: FormInstance<any>;
}
export const Idiomas = ({ form }: Props) => {
  const [nativo, setNativo] = useState<boolean>(true);

  useEffect(() => {
    setNativo(!form.getFieldValue("es_nativo"));
  }, [form]);

  const onChange = (e: CheckboxChangeEvent) => {
    setNativo(!e.target.value);
    if (e.target.value) {
      form.setFieldsValue({ idiomas: [{ nombre: "" }] });
    }
  };

  return (
    <>
      <Divider orientation='center'>Solo Nativo</Divider>
      <Row wrap={true}>
        <Col xs={24} xl={24}>
          <Form.Item
            style={{ width: "95%" }}
            name='es_nativo'
            label='Solo hablo y escribo mi idioma nativo'
            rules={[{ required: true, message: "Escoja una opción" }]}
          >
            <Radio.Group onChange={onChange}>
              <Radio value={true}> Si </Radio>
              <Radio value={false}> No </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation='center'>Idiomas Adicionales</Divider>

      <Form.List name='idiomas' initialValue={[{ nombre: "" }]}>
        {(fields = [], { add, remove }) => {
          return (
            <>
              {fields.map(({ key, name, ...restField }) => {
                return (
                  <Row wrap={true} key={key}>
                    <Divider>{name + 1}</Divider>
                    <Col xs={24} md={24} lg={24}>
                      <Space style={{ display: "flex", marginBottom: 8 }} align='baseline'>
                        <Row wrap={true}>
                          <Col xs={12} xl={6}>
                            <Form.Item
                              {...restField}
                              name={[name, "nombre"]}
                              rules={[
                                {
                                  required: nativo,
                                  message:
                                    "Escriba el nombre del idiomas                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             ",
                                },
                              ]}
                              label={`Idioma #${name + 1}`}
                              style={{ width: "97%" }}
                            >
                              <Input placeholder='Escriba el idioma' disabled={!nativo} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} xl={6}>
                            <Form.Item
                              label={`Dominio al hablar #${name + 1}`}
                              {...restField}
                              name={[name, "nivel_oral"]}
                              style={{ width: "97%" }}
                              rules={[{ required: nativo, message: "Seleccione un nivel" }]}
                            >
                              <Select options={data} placeholder='SELECCIONE UN NIVEL' disabled={!nativo} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} xl={6}>
                            <Form.Item
                              {...restField}
                              name={[name, "nivel_escrito"]}
                              style={{ width: "97%" }}
                              rules={[{ required: nativo, message: "Seleccione un nivel" }]}
                              label={`Dominio al escribir #${name + 1}`}
                            >
                              <Select options={data} placeholder='Seleccione un nivel' disabled={!nativo} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} xl={6}>
                            <Form.Item
                              {...restField}
                              name={[name, "nivel_lectura"]}
                              rules={[{ required: nativo, message: "Seleccione un nivel" }]}
                              label={`Dominio para leer #${name + 1}`}
                              style={{ width: "97%" }}
                            >
                              <Select options={data} placeholder='Seleccione un nivel' disabled={!nativo} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <MinusCircleOutlined
                          onClick={() => {
                            if (name >= 0) return remove(name);
                          }}
                        />
                      </Space>
                    </Col>
                  </Row>
                );
              })}
              <Form.Item>
                <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                  Añadir Idioma
                </Button>
              </Form.Item>
            </>
          );
        }}
      </Form.List>
    </>
  );
};
